export const ids = {
  scheduleWidget: 'schedule-widget',
  scheduleItem: 'schedule-item',
};

export const doctorAliases = {
  /**
   * Используется для:
   * - Отрисовка расписания.
   * - Тестирования рабочих и не рабочих дней.
   * - Клика на расписание и открытие модального окна записи.
   */
  base: '1487-lazarenko-ivan-olegovich',
  /**
   * Используется для:
   * - Тестирования отсутствия расписания.
   */
  emptySchedule: '30007-mamaev-nadyir-hasyimovich',
  /**
   * Используется для:
   * - У врача миска, нет таймслотов, но есть расписание и hasOnlineBooking.
   */
  emptySlotsWithMedelement: '3204-baltaev-nurlan-anarkulovich',
};
